'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._CardContent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withExternalPropsCard = require('../withExternalPropsCard');

var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);

var _CardContentStyled = require('./styles/CardContentStyled');

var _externalPropTypes = require('../externalPropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = _extends({
  first: _propTypes2.default.bool,
  last: _propTypes2.default.bool
}, _externalPropTypes.externalPropTypes);

var defaultProps = _extends({
  first: false,
  last: false
}, _externalPropTypes.externalDefaultProps);

var _CardContent = exports._CardContent = function _CardContent(_ref) {
  var last = _ref.last,
      first = _ref.first,
      children = _ref.children,
      externalProps = _ref.externalProps;
  return _react2.default.createElement(
    _CardContentStyled.CardContentStyled,
    { last: last, first: first, size: externalProps.size },
    children
  );
};

_CardContent.displayName = 'CardContent';
exports.default = (0, _withExternalPropsCard2.default)(_CardContent);


_CardContent.propTypes = propTypes;
_CardContent.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-card/dist/CardContent/CardContent.js
// module id = 586
// module chunks = 0